import React, { Component } from 'react'
import ReactPlayer from 'react-player/file'
import { Layout } from '../widgets'
import { formattedDuration, Loading } from '../shared'
import AppStoreBanner from './AppStoreBanner'

import noteImg from '../images/note.svg'
import effectImg from '../images/effect.svg'
import pauseImg from '../images/pause.svg'
import playImg from '../images/play.svg'
import skip_previousImg from '../images/skip_previous.svg'


class AudioPlayer extends Component {
  state = {
    playing: false,
    volume: 1.0,
    muted: false,
    progress: 0,
    duration: 0,
  }

  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing })
  }

  handleSkipPrevious = () => {
    this.player.seekTo(0)
  }

  handleVolumeChange = (e) => {
    this.setState({ volume: parseFloat(e.target.value) })
  }

  handleToggleMuted = () => {
    this.setState({ muted: !this.state.muted })
  }

  handlePlay = () => {
    this.setState({ playing: true })
  }

  handlePause = () => {
    this.setState({ playing: false })
  }

  handleSeekMouseDown = (e) => {
    this.setState({ seeking: true })
  }

  handleSeekChange = (e) => {
    this.setState({ progress: parseFloat(e.target.value) })
  }

  handleSeekMouseUp = (e) => {
    this.setState({ seeking: false })
    this.player.seekTo(parseFloat(e.target.value))
  }

  handleProgress = (state) => {
    if (!this.state.seeking && this.state.playing) {
      // only update 'played', ignore 'playedSeconds', 'loadedSeconds', and 'loaded'
      this.setState({ progress: state.played })
    }
  }

  handleEnded = () => {
    this.setState({ playing: false }, () => this.player.seekTo(0))
  }

  handleDuration = (duration) => {
    this.setState({ duration })
  }

  handleOnSeek = (value) => {
    this.setState({ progress: value / this.state.duration })
  }

  ref = (player) => {
    this.player = player
  }

  render () {
    const {
      loading,
      audioUrl,
      artworkUrl,
      title,
      artist,
      effect,
      is_featured,
    } = this.props

    const {
      playing,
      volume,
      muted,
      progress,
      duration,
    } = this.state

    if (loading) {
      return (<Loading />)
    }

    return (
      <div className='body-container body-container--fullscreen'>
        <Layout className='fullscreen'>
          <ReactPlayer
            ref={this.ref}
            width='0'
            height='0'
            url={audioUrl}
            playing={playing}
            volume={volume}
            muted={muted}
            onPlay={this.handlePlay}
            onPause={this.handlePause}
            onSeek={this.handleOnSeek}
            onEnded={this.handleEnded}
            onProgress={this.handleProgress}
            onDuration={this.handleDuration}
          />

          <div className='audio-player-background'>
            <img src={artworkUrl} alt='' />
          </div>

          <div className='audio-player'>
            <div className='artwork'>
              <img className={artworkUrl || 'fallback'} src={artworkUrl ? artworkUrl : noteImg} alt='' />
            </div>

            <div className='bottom-content'>
              <div className='title-artist-effect'>
                <div className={`title ${is_featured ? 'featured' : ''}`}>{title}</div>
                <div className='artist'>{artist}</div>
                {effect &&
                  <div className='effect'>
                    <img src={effectImg} alt='' />
                    <div>{effect}</div>
                  </div>
                }
              </div>

              <div className='seek-controls'>
                <div className='duration'>{formattedDuration(duration * progress)}</div>
                <AudioPlayer.SeekBar
                  className='seek-bar'
                  progress={progress}
                  handleMouseDown={this.handleSeekMouseDown}
                  handleChange={this.handleSeekChange}
                  handleMouseUp={this.handleSeekMouseUp}
                />
                <div className='duration'>{formattedDuration(duration)}</div>
              </div>

              <div className='playback-controls-container'>
                <div className='playback-controls'>
                  <div className='playback-controls--left'>
                    <AudioPlayer.SkipPrevious
                      className='player-button skip-previous'
                      onClick={this.handleSkipPrevious}
                    />
                  </div>
                  <AudioPlayer.PlayPause
                    className='player-button play-pause'
                    onClick={this.handlePlayPause}
                    playing={playing}
                  />
                  <div className='playback-controls--right'></div>
                </div>
              </div>
            </div>

            <AppStoreBanner />

          </div>
        </Layout>
      </div>
    )
  }
}

AudioPlayer.PlayPause = ({ className, onClick, playing }) => (
  <div className={className} onClick={onClick}>
    <img src={playing ? pauseImg : playImg} alt='play' />
  </div>
)

AudioPlayer.SkipPrevious = ({ className, onClick }) => (
  <div className={className} onClick={onClick}>
    <img src={skip_previousImg} alt='skip previous' />
  </div>
)

AudioPlayer.SeekBar = ({ className, progress, handleMouseDown, handleChange, handleMouseUp }) => (
  <input
    className={className}
    type='range'
    min={0}
    max={0.9999}
    step='any'
    value={progress}
    onChange={handleChange}
    // desktop support
    onMouseDown={handleMouseDown}
    onMouseUp={handleMouseUp}
    // mobile support
    onTouchStart={handleMouseDown}
    onTouchEnd={handleMouseUp}
  />
)

export default AudioPlayer
